import { createFileRoute } from "@tanstack/react-router";

import { StoreList } from "@/founder/stores/StoreList";

export const Route = createFileRoute("/founder/stores/")({
    component: StoreList,
});
